const $window = $(window);
// const breakPoint = 767;
const breakPoint = 1199;

let resizeFlag = false;
let windowWidth = $window.width();
let windowHeight = $window.height();

let url = location.href;

//ヘッダーの開閉
const headerToggle = () => {
  //toggle
  const $header = $('.st-Header');
  const $headerTrigger = $('.st-Header_Hamburger');
  const $headerNavi = $('.sw-Navi');
  const $headerNaviItem = $('.sw-Navi nav ul li').find('a');
  $headerTrigger.each(function(){
    $(this).on('click', function(){
      $header.toggleClass('opened');
      $headerNavi.toggleClass('opened');
      return false;
    });
  });
  $headerNaviItem.on('click', function(){
    $header.removeClass('opened');
    $headerNavi.removeClass('opened');
  });
};

//ページTOP
const pageTop = () =>{
  const topBtn = $('.sw-BackToTop');
  topBtn.css({visibility:'hidden',opacity: 0});
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      topBtn.css({visibility:'visible',opacity: 1});
    } else {
      topBtn.css({visibility:'hidden',opacity: 0});
    }
  });
  topBtn.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 1000);
    return false;
  });
};

//外部ページからのアンカー
const externalAnchor = () => {
  $(window).on('load' , function() {

      const url = $(location).attr('href');
      if (url.indexOf("?id=") == -1) {
      }else {
        const url_sp = url.split("?id=");
        const hash = '#' + url_sp[url_sp.length - 1];
        const tgt = $(hash);
        let pos;
        if(windowWidth > breakPoint){
          pos = tgt.offset().top - 80;
        }else{
          pos = tgt.offset().top - windowWidth * 0.146484375;
        }
        $("html, body").animate({
          scrollTop: pos
        }, 1000, "swing");
      }
  });
}

//ページ内リンクのアニメーション
const anchorScroll = () => {
  const $anchor = $('a[href^=#]');
  $anchor.click(function () {
    const speed = 1000;
    const href = $(this).attr('href');
    const target = $(href == '#' || href == '' ? 'html' : href);
    let position = target.offset().top;
    if(windowWidth > breakPoint){
      position = target.offset().top;
    }else{
      position = target.offset().top;
    }
    $('html, body').animate({
      scrollTop: position
    }, speed, 'swing');

    setTimeout(function(){
      currentNavi();
    },100);

    // return false;
  });
};

// preload
const preload = () =>{
  $(window).on('load' , function() {
    $("body").removeClass("preload");
  });
};

// resizing
const resizing = () =>{
  var timer = 0;
  $(window).on('resize' , function() {
    $("body").addClass("resizing");
    if (timer > 0) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      $("body").removeClass("resizing");
    }, 100);
  });
};

//export
export { headerToggle, pageTop, anchorScroll, preload, resizing };


// WEBPACK FOOTER //
// ./src/vstation_program/assets/js/include/module.js